import { TPopupDefaultActions } from '../../../../../../../../../../../../shared/components/popup/services/popup.service.ts';
import {
  Popup,
  TPopupComponent,
} from '../../../../../../../../../../../../shared/components/popup/popup.abstract.tsx';
import { FC, useMemo } from 'react';
import { styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Theme } from '../../../../../../../../../../../../shared/styles/theme/theme.ts';

export class SamePeriodPopup extends Popup<ISamePeriodPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const { t } = useTranslation();
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 500 },
        }));
      }, []);

      return (
        <SWrapper fullWidth stream={stream} popupTitle={t('common.warning')}>
          <Typography variant='caption' fontSize={16}>
            {t('article.special_prices_for_this_date_already_exist')}.
          </Typography>
          <Typography
            sx={{
              borderLeft: `2px solid ${Theme.palette.primary.light}`,
              padding: '3px 10px',
              display: 'flex',
              marginTop: '24px',
              marginBottom: '5px',
              alignItems: 'center',
              color: 'text.secondary',
            }}
          >
            {t('article.steps_for_this_date_already_exists')}
          </Typography>
        </SWrapper>
      );
    };
  }
}

export interface ISamePeriodPopup {
  action: TPopupDefaultActions;
}
